import { render } from "./GalleryImages.vue?vue&type=template&id=ea78e998&scoped=true"
import script from "./GalleryImages.vue?vue&type=script&lang=js"
export * from "./GalleryImages.vue?vue&type=script&lang=js"

import "./GalleryImages.vue?vue&type=style&index=0&id=ea78e998&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea78e998"]])

export default __exports__